<template>
    
    <a-list-item-meta
        :title="interviewerName"
        :description="interviewerMobile"
    >
        <!-- <a-avatar
            slot="avatar"
            :size="48"
            shape="square"
            :src="interviewerImage"
        /> -->
    </a-list-item-meta>
    
</template>

<script>


export default {
    props: {
        item: {
            type: Object,
            required: true
        } 
    },
    computed: {
        interviewerImage() {
            if (this.item && this.item.imageUrl && this.item.imageUrl.length > 0)
                return this.item.imageUrl;
            return '/images/default-avatar.jpg';
        },
        interviewerName() {
            let name = '';
            if (this.item && this.item.name)
                name = this.item.name;
            if (this.item && this.item.address && this.item.address.length > 0)
                name = name + ", " + this.item.address;
            return name;
        },
        interviewerMobile() {
            if (this.item && this.item && this.item.mobile)
                return this.item.mobile;
            return '';
        }
    }
}
</script>